import { TaskDefinition, TaskSort } from '@tasks/tasks.types';

/**
 * WORKAROUND #1 — load-time healing.
 * Returns a new definition with `fields` extended to include any field
 * referenced by `table.sort`
 */
export function ensureSortFieldsInSelect(definition: TaskDefinition | undefined): TaskDefinition | undefined {
  if (!definition) return definition;
  const sort = (definition.table as { sort?: TaskSort[] } | undefined)?.sort;
  const fields = definition.fields;
  if (!sort?.length || !Array.isArray(fields)) return definition;

  const missing = sort.map((s) => s?.field).filter((f): f is string => !!f && !fields.includes(f));

  if (!missing.length) return definition;

  return {
    ...definition,
    fields: [...fields, ...Array.from(new Set(missing))],
  };
}

export function dropOrphanedSortOnFieldsChange(
  sort: TaskSort[] | undefined,
  newFields: string[],
): TaskSort[] | undefined {
  if (!sort?.length) return sort;
  const cleaned = sort.filter((s) => newFields.includes(s.field));
  return cleaned.length === sort.length ? sort : cleaned;
}
